'use strict';

export default class SearchNoResults extends React.Component {
    render() {
        const {type, timing} = this.props;

        let text = tMsg('Нет подходящих предложений по данному маршруту, но Вы можете оставить заявку.');
        if(type === 'seats' && timing.length > 0) text = tMsg('Нет подходящих рейсов на выбранную дату, но Вы можете выбрать ближайшую, или оставить заявку.');

        return <div className="message">
            <i className="icon-error"/>
            <span>{text}</span>
        </div>
    }
}
